import { ca } from '@cian/analytics';

export const trackNewbuildingInfoLabelClick = (id: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'nb_offer_label',
    action: 'click_sopr',
    products: [{ id }],
  });
};
